import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import styles from './EditPlot.module.scss';

const EditPlot = () => {
  const { plotId } = useParams();
  const navigate = useNavigate();
  const [plot, setPlot] = useState({
    deceasedFirstName: '',
    deceasedLastName: '',
    status: '',
    block: '',
    plotRow: '',
    grave: ''
  });
  const [image, setImage] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const fileInputRef = useRef(null); 
  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchPlot = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_URL}/plots/${plotId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setPlot(res.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch plot details');
        console.error(err);
      }
    };

    fetchPlot();
  }, [plotId, token]);

  const handleChange = (e) => {
    setPlot({ ...plot, [e.target.name]: e.target.value });
  };

 
  const handleImageClick = (e) => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); 
    }
  };

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const formData = new FormData();
    formData.append('deceasedFirstName', plot.deceasedFirstName);
    formData.append('deceasedLastName', plot.deceasedLastName);
    formData.append('status', plot.status);
    formData.append('block', plot.block);
    formData.append('plotRow', plot.plotRow);
    formData.append('grave', plot.grave);
    
    if (image) {
      formData.append('image', image);
    }
  
    try {
      const res = await axios.put(`${process.env.REACT_APP_URL}/plots/${plotId}`, formData, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      navigate('/plots');
    } catch (err) {
      setError('Failed to update plot details');
      console.error(err);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className={styles.editPlotContainer}>
      <h2>Edit Plot</h2>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className={styles.formGroup}>
          <label>First Name</label>
          <input
            type="text"
            name="deceasedFirstName"
            value={plot.deceasedFirstName}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles.formGroup}>
          <label>Last Name</label>
          <input
            type="text"
            name="deceasedLastName"
            value={plot.deceasedLastName}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles.formGroup}>
          <label>Status</label>
          <input
            type="text"
            name="status"
            value={plot.status}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles.formGroup}>
          <label>Block</label>
          <input
            type="text"
            name="block"
            value={plot.block}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles.formGroup}>
          <label>Row</label>
          <input
            type="text"
            name="plotRow"
            value={plot.plotRow}
            onChange={handleChange}
            required
          />
        </div>
        <div className={styles.formGroup}>
          <label>Grave</label>
          <input
            type="text"
            name="grave"
            value={plot.grave}
            onChange={handleChange}
            required
          />
        </div>

        <div className={styles.formGroup}>
          <label>Image</label>
          {plot.image && !image ? (
            <>
            <div className={styles.imagePreview} onClick={handleImageClick}>
              <img 
                src={`${process.env.REACT_APP_URL}uploads/${plot.image}`} 
                alt="Plot" 
                className={styles.plotImage} 
              />
            </div>
            <input 
            type="file" 
            name="image" 
            accept="image/*" 
            ref={fileInputRef} 
            onChange={handleImageChange} 
            style={{ display: 'none' }} // Hidden file input
          />
          </>
          ) : (
            <input 
              type="file" 
              name="image" 
              accept="image/*" 
              ref={fileInputRef} 
              onChange={handleImageChange} 
            
            />
          )}
        </div>


        <button type="submit" className={styles.saveButton}>
          Save Changes
        </button>
      </form>
    </div>
  );
};

export default EditPlot;
